const config = {
  PROXY: process.env.NODE_ENV === "production" ? "https://proxy.appcraft.events" : "http://localhost:3320",
  API: "https://app.appcraft.events/api",
  IMAGE: "https://app.appcraft.events/images"
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js